import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function createOrUpdateBonificationByStock(body) {
    const response = await axios.put(
        `${REACT_APP_API}/bonifications/conventional/stock`,
        body
    )
    return response?.data?.data
}
